(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["notification-bar"]) return;
  try {
     
(function() {
  const timerContainer = document.getElementById("countdown-timer");
  if (!timerContainer) return;

  const rawDate = timerContainer.dataset.targetDate;
  if (!rawDate) return;

  const targetDate = new Date(`${rawDate}-07:00`).getTime();

  const updateTimer = () => {
    const now = new Date().getTime();
    const distance = targetDate - now;

    if (distance < 0) {
      timerContainer.innerHTML = "EXPIRED";
      return;
    }

    const days = Math.floor(distance / (1000 * 60 * 60 * 24));
    const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((distance % (1000 * 60)) / 1000);

    document.getElementById("countdown-days").innerText = days.toString().padStart(2, '0');
    document.getElementById("countdown-hours").innerText = hours.toString().padStart(2, '0');
    document.getElementById("countdown-minutes").innerText = minutes.toString().padStart(2, '0');
    document.getElementById("countdown-seconds").innerText = seconds.toString().padStart(2, '0');
  };

  updateTimer();
  setInterval(updateTimer, 1000);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-grid"]) return;
  try {
    
  Shopify.queryParams = {};

  // Preserve existing query parameters
  if (location.search.length) {
    var params = location.search.substr(1).split('&');

    for (var i = 0; i < params.length; i++) {
      var keyValue = params[i].split('=');

      if (keyValue.length) {
        Shopify.queryParams[decodeURIComponent(keyValue[0])] = decodeURIComponent(keyValue[1]);
      }
    }
  }

  // Update sort_by query parameter on select change
  document.querySelector('#sort-by').addEventListener('change', function(e) {
    var value = e.target.value;

    Shopify.queryParams.sort_by = value;
    location.search = new URLSearchParams(Shopify.queryParams).toString();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-page"]) return;
  try {
     
  (function() {
  let slideIndex = 0;
  let dots;

  function init() {
    // UPDATED: Matches your new render class
    let productImage = document.querySelector(".product-page-images");
    if (!productImage) return;

    // UPDATED: Matches your new render dots class
    dots = document.getElementsByClassName("image-dots");

    for (let i = 0; i < dots.length; i++) {
      dots[i].addEventListener("click", function(e) {
        e.preventDefault(); // Prevents jumping if using <a> tags
        showSlides(i);
        scrollToImage(i);
      });
    }

    showSlides(slideIndex);
    productImage.addEventListener("scroll", updateActiveDotOnScroll);
  }

  function showSlides(n) {
    if (!dots.length) return;
    slideIndex = Math.max(0, Math.min(n, dots.length - 1));

    for (let i = 0; i < dots.length; i++) {
      dots[i].classList.remove("image-dots-active");
    }
    dots[slideIndex].classList.add("image-dots-active");
  }

  function scrollToImage(n) {
    let productImage = document.querySelector(".product-page-images");
    // FIX: Instead of clientWidth (which is the container), we find the specific image offset
    let images = productImage.querySelectorAll('img, video, model-viewer');
    if (images[n]) {
       productImage.scroll({
         left: images[n].offsetLeft,
         behavior: "smooth"
       });
    }
  }

  function updateActiveDotOnScroll() {
    let productImage = document.querySelector(".product-page-images");
    let scrollLeft = productImage.scrollLeft;
    let images = productImage.querySelectorAll('img, video, model-viewer');
    
    // Find which image is currently most visible in the viewport
    let currentIndex = 0;
    images.forEach((img, index) => {
      if (scrollLeft >= img.offsetLeft - (productImage.clientWidth / 2)) {
        currentIndex = index;
      }
    });

    showSlides(currentIndex);
  }

  init();
})();


  } catch(e) { console.error(e); }
})();
})();
